import { HTTP } from './helpers/http.js'

export default {
  getById(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/revs/${revId}`
    return HTTP.get(url)
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/revs`
    return HTTP.post(url, data)
  },

  update(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/revs/${revId}`
    return HTTP.put(url, data)
  },

  updateImprovementIdeas(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}`
    return HTTP.patch(url, data)
  },

  remove(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/revs/${revId}`
    return HTTP.delete(url)
  },

  share(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/shares`
    const { sharedBy, sharedTo, message, sharedObjectId } = payload

    return HTTP.post(url, {
      organizationId,
      sharedBy,
      sharedTo,
      message,
      sharedObjectId,
      sharedObjectType: 'Rev',
    })
  },

  addValidation({
    organizationId,
    revId,
    validationType,
    isValidated,
    validatedReview,
  }) {
    const url = `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/validations`
    return HTTP.post(url, {
      type: validationType,
      isValidated,
      validatedReview,
    })
  },

  editValidation({
    organizationId,
    revId,
    validationType,
    isValidated,
    validatedReview,
    validationId,
  }) {
    const url = `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/validations/${validationId}`
    return HTTP.put(url, {
      type: validationType,
      isValidated,
      validatedReview,
    })
  },

  removeValidation({ organizationId, revId, validationType }) {
    const url = `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/validations/${validationType}?type=${validationType}`
    return HTTP.delete(url)
  },

  addHighlight({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/highlights`
    )
  },

  removeHighlight({ organizationId, revId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/highlights`
    )
  },

  getIdeaMatches(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/ml/search-implement-rev`
    return HTTP.post(url, data)
  },

  savePartialValidation(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/validation-impacts`
    return HTTP.patch(url, data)
  },

  addImplementValidation({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/implementation-validations`
    )
  },

  removeImplementationValidation({ organizationId, revId, validationId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/implementation-validations/${validationId}`
    )
  },

  addImpactValidation({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/impact-validations`
    )
  },

  removeImpactValidation({ organizationId, revId, validationId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/improvement-ideas/${revId}/impact-validations/${validationId}`
    )
  },
}
